export default "__VITE_ASSET__BYSk19eC__"